var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"LibSvg",style:({
    width: _vm.size,
    height: _vm.size,
    margin: `${_vm.top} ${_vm.right} ${_vm.bottom} ${_vm.left}`,
    color: _vm.color,
  }),attrs:{"title":_vm.title},domProps:{"innerHTML":_vm._s(_vm.svg)},on:{"mouseenter":function($event){return _vm.enter($event.target)},"mouseleave":function($event){return _vm.leave($event.target)},"mousedown":function($event){return _vm.down($event.target)},"mouseup":function($event){return _vm.up($event.target)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }